import { AgentModelVersionDto } from '@generated/models/agent-model-version-dto';
import { ModelVersionFullDto } from '@generated/models/model-version-full-dto';

/**
 * Снимок версии модели из полного ответа бэка.
 *
 * Зачем он нужен. Кнопка выбора модели пишет на себе имя выбранной
 * версии, а ищет его в иерархии, которую страница загрузила заранее. С
 * включённым «только рекомендованные» в той иерархии лежит не всё: если
 * версию выбрали из полного каталога (а встроенный агент так и делает —
 * он спрашивает каталог у MCP), искать её там бесполезно, и на кнопке
 * оставалась общая надпись «Select LLM Model» при верно записанном
 * значении.
 *
 * Снимок закрывает этот разрыв: одна ручка `/api/Models/versions/{id}`,
 * и подпись есть сразу, не дожидаясь, пока страница перезагрузит
 * иерархию целиком.
 */
export function modelVersionSnapshot(full: ModelVersionFullDto): AgentModelVersionDto {
  const model = full.model;
  return {
    id: full.id,
    name: full.name,
    version: full.version,
    description: full.description,
    is_active: full.is_active,
    is_recommended: full.is_recommended,
    model: model
      ? {
          id: model.id,
          code: model.code,
          name: model.name,
          allow_speed: model.allow_speed,
          allow_temperature: model.allow_temperature,
          model_type_code: model.model_type?.code,
        }
      : undefined,
    author: model?.author
      ? { id: model.author.id, code: model.author.code, name: model.author.name }
      : undefined,
    gateway: model?.gateway
      ? { id: model.gateway.id, code: model.gateway.code, name: model.gateway.name }
      : undefined,
  };
}
